<p-menu #navMenu [model]="items()" [class]="state" styleClass="min-w-0 max-w-50 h-full flex flex-col border-transparent left-nav dark:bg-surface-950">
    <ng-template #submenuheader let-item>
        @if (item.label && item.visible) {
            @if (transitionDirection === 'Collapse') {
                <span class="text-secondary max-w-full overflow-x-hidden">{{ item.label }}</span>
            }
            @else {
                <span class="text-secondary w-10 text-ellipsis inline-block overflow-x-hidden" [class]="item.shortTitle ? 'text-center' : ''"
                    style="font-size:0.625rem; line-height:1.5rem" [pTooltip]="item.label">{{item.shortTitle ?? item.label}}
                </span>
            }
        }
    </ng-template>
    <ng-template #item let-item>
        @if (item.routerLink) {
            <a [routerLink]="item.routerLink" class="p-menu-item-link" routerLinkActive="p-menu-item-link-active"
                [pTooltip]="transitionDirection === 'Expand' ? item.title : ''">
                <span [class]="item.icon"></span>
                @if (item.label) {
                    <span class="ml-2 whitespace-nowrap">{{ item.label }}</span>
                }
            </a>
        }
        @else {
            <a [href]="item.url" class="p-menu-item-link"
                [pTooltip]="transitionDirection === 'Expand' ? item.title : ''">
                <span [class]="item.icon"></span>
                @if (item.label) {
                    <span class="ml-2 whitespace-nowrap overflow-hidden text-ellipsis">{{ item.label }}</span>
                }
            </a>
        }
    </ng-template>
    <ng-template #end class="flex justify-end">
        <p-button #toggle [label]="transitionDirection === 'Expand' ? '' : transitionDirection"
        class="mr-1" icon="pi pi-arrow-circle-left" text="true" iconPos="right"
        [pTooltip]="transitionDirection === 'Collapse' ? '' : transitionDirection + ' sidebar'"
        (click)="toggleNavWidth(transitionDirection, toggle)"/>
    </ng-template>
</p-menu>
